/**
 * @module fetch.helpers
 */

type Protocol = "http:" | "https:" | "ws:" | "wss:";

/**
 * Constructs a fully qualified url from a root-relative one based on
 * the runtime location.
 * The host protocol may be overridden when switching protocols.
 *
 * Used to ensure node tests use a valid url
 * See https://github.com/oidualc/rtkquery-msw-vitest-error/
 *
 */
export const getBaseUrl = (basePath = "", protocol?: Protocol) => {
  const { host, protocol: hostProtocol } = globalThis.location;
  const path =
    basePath === "" || basePath.startsWith("/") ? basePath : "/" + basePath;
  return `${protocol ?? hostProtocol}//${host}${path}`;
};
